import React, { Component } from 'react';
import SendEmail from '../../../components/send-email-component';
import moment from 'moment';
import { observer } from 'mobx-react';

@observer
export default class StepSendEmail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isSaving: false,
            isSaved: false,
        };
    }

    handlePersistEmailDraft(model, templateId) {
        this.setState({ isSaving: true, isSaved: false });
        const step = Object.assign({}, this.props.step);
        step.state.data.model = model;
        step.state.data.drafts = {};
        step.state.data.drafts[this.props.typeOfSale] = model;
        step.state.data.modelSaveDate = new moment().format();
        step.state.data.templateId = templateId;
        this.props.updateStepState(step).then(() => {
            this.setState({ isSaving: false, isSaved: true });
        });
    }

    render() {
        let model = null;
        if (this.props.step.state.isComplete) {
            model = this.props.model;
        } else if (this.props.step.state.data.drafts && this.props.timelineGeneratedDate) {
            const timelineGeneratedDate = moment(this.props.timelineGeneratedDate),
                draftDate = this.props.step.state.data.modelSaveDate,
                isDraftStale = timelineGeneratedDate.isAfter(moment(draftDate));
            model =
                this.props.step.state.data.drafts && !isDraftStale
                    ? this.props.step.state.data.drafts[this.props.typeOfSale]
                    : null;
        } else {
            model = this.props.step.state.data.drafts ? this.props.step.state.data.drafts[this.props.typeOfSale] : null;
        }
        return (
            <SendEmail
                {...this.props}
                isComplete={this.props.step.state.isComplete}
                model={model}
                isSaving={this.state.isSaving}
                isSaved={this.state.isSaved}
                draftTemplateId={this.props.step.state.data.templateId}
                onEmailModelChange={this.handlePersistEmailDraft.bind(this)}
                invoiceData={this.props.invoiceData}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/workflow/steps/components/step-send-email.js